<template>
  <section class="page">
    <div class="page__header">
      <div class="page__title">
        <SharedBreadcrumbs :breadcrumbs />

        <FaqSearch />
      </div>

      <h1 class="typography__headline1">Настройки записей</h1>
    </div>

    <div class="page__content">
      <FaqArticlesAside :menu />

      <FaqArticlesContent>
        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="kak-popast"
            class="typography__headline2"
          >
            Как попасть
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>Давайте проверим настройки записей вашего проекта.</p>

            <p>
              В&nbsp;меню слева перейдите в&nbsp;раздел &laquo;Данные проекта&raquo;. На&nbsp;появившейся странице
              выберите &laquo;Записи&raquo;.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/nastroyki-zapisey-1.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />
        </div>

        <div class="base-content-block">
          <FaqArticlesBlockHeading
            id="nastroyki-zapisei"
            class="typography__headline2"
          >
            Настройки записей
          </FaqArticlesBlockHeading>

          <div class="block-small">
            <p>По-умолчанию выставлены стандартные настройки для всех новых проектов.</p>

            <p>
              В&nbsp;минимальном времени длительности записи можно выбрать значение от&nbsp;15&nbsp;минут
              до&nbsp;1&nbsp;часа. Меньше этого времени длительность записи нельзя будет указать.
            </p>

            <p>
              В&nbsp;минимальном времени отмены записи можно выбрать значение от&nbsp;1&nbsp;до&nbsp;48&nbsp;часов. Если
              останется меньше времени до&nbsp;записи&nbsp;&mdash; клиент не&nbsp;сможет её&nbsp;отменить сам через
              личный кабинет.
            </p>

            <p>
              В&nbsp;паузе между сеансами можно выбрать значение от&nbsp;0&nbsp;до&nbsp;1&nbsp;часа. Можно установить
              если нужны перерывы между всеми записями всех филиалов.
            </p>

            <p>
              В&nbsp;шаге интервалов можно выбрать значение от&nbsp;5&nbsp;минут до&nbsp;1&nbsp;часа. Влияет
              на&nbsp;показ клиенту слотов для записи. Например, если установлен интервал 15&nbsp;минут, будут видны
              слоты&nbsp;на: 08:00, 08:15, 08:30 и&nbsp;08:45.
            </p>

            <p>
              После изменений нажмите &laquo;Сохранить&raquo; в&nbsp;самом низу страницы. После успешного сохранения
              увидите в&nbsp;правом верхнем углу уведомление.
            </p>
          </div>

          <FaqArticlesImageModalButton
            image-source="/images/faq/nastroyki-zapisey-2.jpg"
            @click="(imageSource) => (activeImageSource = imageSource)"
          />

          <p>
            С настройками записей разобрались. Самое время перейти к заполнению
            <BaseLink to="/faq/articles/kategorii-uslug">категорий услуг</BaseLink>.
          </p>
        </div>
      </FaqArticlesContent>
    </div>

    <div class="page__related">
      <h2
        class="typography__headline2"
        v-html="t('pages.faq.otherArticles')"
      />

      <FaqArticlesList :articles="relatedArticles" />
    </div>
  </section>

  <LazyFaqArticlesImageModal
    v-if="isModalOpen(MODAL.FaqArticlesImage) && activeImageSource"
    :src="activeImageSource"
    @close="() => (activeImageSource = null)"
  />
</template>

<script lang="ts" setup>
const { t } = useI18n();
const { isModalOpen } = useModalStore();
const activeImageSource = ref<null | string>(null);

const breadcrumbs = [
  {
    name: t("pages.faq.title"),
    url: "/faq",
  },
  {
    name: "Онлайн-&#65279;запись",
    url: "/faq/categories/onlayn-zapis",
  },
  {
    name: "Настройки записей",
  },
];

const menu = [
  {
    name: "Как&nbsp;попасть",
    url: "kak-popast",
  },
  {
    name: "Настройки&nbsp;записей",
    url: "nastroyki-zapisei",
  },
];

const relatedArticles = [
  {
    name: "Категории услуг",
    slug: "kategorii-uslug",
  },
  {
    name: "Добавление и&nbsp;редактирование услуги",
    slug: "dobavleniye-i-redaktirovaniye-uslugi",
  },
  {
    name: "Список услуг и&nbsp;их данные",
    slug: "spisok-uslug-i-ikh-dannye",
  },
  {
    name: "Добавление и&nbsp;редактирование записи",
    slug: "dobavlenie-i-redaktirovanie-zapisi",
  },
];

useSeoMeta({
  title: "Настройки записей",
});
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__header {
  display: flex;
  flex-direction: column;
  row-gap: 40px;
}

.page__title {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}

.page__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

@media (--xl) {
  .page__content {
    flex-direction: row-reverse;
    justify-content: start;
    align-items: start;
  }
}

.page__related {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
}
</style>
